<template>
  <section class="connection-settings">
    <div class="connection-settings_header">
      <h1>Pending Invitations</h1>
      <div class="connection-settings_header--filter">
        <div class="connection-settings_header--filter-input-wrapper">
          <div class="filter-input">
            <input type="text" placeholder="Search" />
            <button class="filter">
              <img src="/static/img/filter.svg" alt="" />
              Filter
            </button>
          </div>
        </div>
        <button disabled>
          <img src="/static/img/heart.svg" alt="" />
          <span>Feedback</span>
        </button>
      </div>
    </div>
    <div class="connection-settings_connections">
      <div
        v-for="(connection, i) of connections"
        :key="i"
        class="connection-settings_connections--card"
      >
        <img :src="connection.logo" :alt="connection.title" />
        <div class="title">{{ connection.title }}</div>
        <p class="description">
          {{ connection.description }}
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import Connections from "../Connections.js";
export default {
  data() {
    return {
      connections: Connections,
    };
  },
};
</script>
<style scoped lang="scss">
.connection-settings {
  .actions {
    button {
      background: none;
      display: flex;
      align-items: center;
    }
  }

  .name-column {
    display: flex;
    align-items: center;
    gap: 10px;

    .form-check {
      transform: translateY(-12px);
    }
  }

  .name-row {
    display: flex;
    align-items: center;
    gap: 10px;

    .avatar {
      border-radius: 100px;
      background: rgba(60, 120, 255, 0.15);
      width: 40px;
      height: 40px;
    }

    .form-check {
      transform: translateY(-12px);
    }

    span {
      color: #3c78ff;

      font-family: Helvetica, Arial, sans-serif;
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  &_header {
    display: grid;
    gap: 25px;
    margin-bottom: 25px;

    h1 {
      overflow: hidden;
      color: #404040;
      text-overflow: ellipsis;
      font-family: Helvetica, Arial, sans-serif;
      font-size: 35px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    &--actions {
      display: flex;
      justify-content: flex-end;
      gap: 10px;

      button {
        color: #404040;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        background: none;
        border-radius: 0;
        padding: 0;
      }

      &-divider {
        height: 15px;
        width: 2px;
        background: rgba(64, 64, 64, 0.25);
        transform: translateY(1px);
      }
    }

    &--filter {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-input-wrapper {
        display: grid;
        gap: 10px;

        .filter-input {
          display: flex;
          gap: 10px;
        }

        span {
          color: #404040;
          font-family: Helvetica, Arial, sans-serif;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }

        input {
          height: 40px;
          width: 250px;
        }

        .filter {
          background: none;
          color: #404040;
          display: flex;
          align-items: center;
          gap: 10px;
        }
      }

      button {
        color: #404040;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        display: flex;
        align-items: center;
        gap: 10px;
        background: transparent;
      }
    }
  }

  &_connections {
    display: flex;
    flex-wrap: wrap;

    gap: 20px;
    flex-direction: column;

    @media (min-width: 564px) {
      flex-direction: row;
    }

    @media (min-width: 768px) {
      justify-content: auto;
      gap: 60px;
    }

    &--card {
      display: flex;
      height: 200px;
      width: 200px;
      padding: 10px 10px 0px 10px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 15px;
      cursor: pointer;

      border-radius: 10px;
      border: 1px solid rgba(0, 0, 0, 0.25);
      background: #fff;

      .title {
        color: #404040;
        text-align: center;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
      }

      .description {
        color: rgba(64, 64, 64, 0.75);
        text-align: center;
        font-family: Helvetica, Arial, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }
    }
  }
}
</style>
